<template>
  <div class="login-page" style="direction: rtl;">
    <div class="input-container">
      <Loader v-if="loading" />
      <div v-if="!loading" class="input-wrapper">
        <div class="main side">
          <div class="main-container">
            <div class="input-heading">
              <span style="font-size: unset;">به سامانه</span>
              <span class="bold" style="font-size: unset;"> سیناپردازش </span>
              <span style="font-size: unset;">خوش آمدید</span>
            </div>
            <div class="spacer"></div>
            <div class="demo-link">
              <button @click="showDemoModal = true" class="demo-link-text">
                <span>مشاهده دمو</span>
              </button>
            </div>
            <div class="shadow-desktop">
              <div class="subtext">
                جهت ورود، نام کاربری و رمز عبور را در فیلدهای مربوط وارد کنید.
              </div>
              <div class="input-label">
                <div class="svg-input">
                  <input type="text" placeholder="نام کاربری" v-model="user" @keypress.enter="sendRequestOnEnter" />
                  <div class="svg-placeholder">
                    <svg fill="#9aa2ac" viewBox="0 0 486.48 506.08" width="22" height="22">
                      <path
                        d="m239.08,339.76c-78.9,0-143.07-76.2-143.07-169.88S160.17,0,239.08,0s143.06,76.2,143.06,169.88-64.17,169.88-143.06,169.88Zm0-295.9c-54.7,0-99.21,56.54-99.21,126.02s44.5,126.01,99.21,126.01,99.2-56.54,99.2-126.01-44.5-126.02-99.2-126.02Z" />
                      <path
                        d="m464.55,506.08H22.38c-11.56,0-21.16-9-21.89-20.56-9.34-149.06,117.75-198.15,186.28-203.29,11.78-1.07,22.49,8.14,23.47,20.22.95,12.04-8.09,22.58-20.17,23.52-6,.52-140.2,12.68-146.02,136.26h396.38c-6.86-41.38-35.13-127.05-152.19-136.26-12.08-.94-21.12-11.48-20.13-23.56.94-12.08,11.77-20.95,23.56-20.13,192.58,15.12,194.81,199.99,194.81,201.87,0,5.83-2.31,11.4-6.42,15.51-4.12,4.11-9.68,6.42-15.51,6.42Z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="eye-container">
                <div class="input-label pass">
                  <div class="svg-input">
                    <input :type="hidePass ? 'password' : 'text'" placeholder="رمز عبور" v-model="pass"
                      @keypress.enter="sendRequestOnEnter" />
                    <div class="svg-placeholder">
                      <svg fill="#9aa2ac" viewBox="0 0 486.32 506.08" width="22" height="26">
                        <path
                          d="m362.83,506.08H123.49C55.4,506.08,0,463.03,0,410.11v-188.32c0-12.09,12.59-21.86,28.14-21.86h430.04c15.55,0,28.14,9.78,28.14,21.86v188.32c0,52.92-55.4,95.97-123.49,95.97ZM56.28,243.66v166.45c0,28.78,30.17,52.23,67.21,52.23h239.33c37.04,0,67.21-23.45,67.21-52.23v-166.45H56.28Z" />
                        <path
                          d="m362.39,243.66c-15.55,0-28.14-9.78-28.14-21.87v-101.22c0-42.37-44.35-76.84-98.86-76.84s-98.87,34.47-98.87,76.84v101.22c0,12.09-12.59,21.87-28.14,21.87s-28.14-9.78-28.14-21.87v-101.22C80.24,54.07,149.82,0,235.39,0s155.14,54.07,155.14,120.58v101.22c0,12.09-12.59,21.87-28.14,21.87Z" />
                        <g>
                          <ellipse cx="241.23" cy="368.76" rx="47.53" ry="36.94" />
                          <path
                            d="m241.21,390.64c-15.55,0-28.14-9.78-28.14-21.87v-58.34c0-12.09,12.59-21.87,28.14-21.87s28.14,9.78,28.14,21.87v58.34c0,12.09-12.59,21.87-28.14,21.87Z" />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <span @click="ShowPassword" class="eye-svg">
                  <EyeSvg />
                </span>
              </div>
              <div class="sample-captcha">
                <vue-recaptcha @verify="handleVerify" />
              </div>
              <button class="login-button" @click="sendrequest(user, pass)">
                ورود به سامانه
              </button>
              <div class="privacy-link">
                <span> من </span>
                <a href="https://www.sinapardazesh.ir/privacy-policy" target="_blank" class="privacy-text">سیاست حفظ
                  حریم خصوصی</a>
                <span> و </span>
                <a href="https://www.sinapardazesh.ir/terms-of-service" target="_blank" class="privacy-text">شرایط
                  استفاده از خدمات</a>
                <span> را می‌پذیرم. </span>
              </div>
            </div>
            <div class="support-phone desktop-right">
              <span>تلفن تماس: <a href="tel:02188745474" class="phone-link">۸۸۸۰۶۸۸۸-۰۲۱</a></span>
            </div>
          </div>
          <div class="mobile-loptop">
            <img :src="`${publicPath}img/nloptop.png`" alt="loptop background" />
          </div>
          <div class="mobile-logo">
            <img :src="`${publicPath}img/logo_embedded.svg`" alt="sinapardazesh logo" />
          </div>
          <div class="license-row">
          </div>
        </div>

        <div class="other side">
          <div class="loptop">
            <img :src="`${publicPath}img/nloptop.png`" alt="loptop background" />
          </div>
          <div class="logo">
            <img :src="`${publicPath}img/logo_embedded.svg`" alt="sinapardazesh logo" />
          </div>
          <div class="license-row desktop">
            <span class="license-right">تمام حقوق مادی و معنوی این سامانه متعلق به شرکت سیناپردازش نوین آریا است.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ################################################################## -->
  <!-- ################################################################## -->
  <!-- ############################ mobilePage ###################### -->
  <!-- ################################################################## -->
  <!-- ################################################################## -->
  <div class="mobile-login-page">
    <div class="mobile-login-container">
      <div class="photo-mobile">
        <img :src="`${publicPath}img/mobilePhoto.png`" alt="mobile photo" />
      </div>
      <div class="logo-mobile">
        <img :src="`${publicPath}img/logo_embedded.svg`" alt="sinapardazesh logo" />
      </div>
      <div class="main side">
        <div class="main-container">
          <div class="input-heading">
            <span style="font-size: unset;">به سامانه</span>
            <span style="font-size: unset;" class="bold"> سیناپردازش </span>
            <span style="font-size: unset;">خوش آمدید</span>
          </div>
          <div class="spacer"></div>
          <div class="demo-text">

          </div>
          <div class="innerframe">
            <div class="subtext">
              جهت ورود، نام کاربری و رمز عبور را در فیلدهای مربوط وارد کنید.
            </div>
            <div class="input-label user">
              <div class="svg-input">
                <input type="text" placeholder="نام کاربری" v-model="user" @keypress.enter="sendRequestOnEnter" />
                <div class="svg-placeholder">
                  <svg fill="#9aa2ac" viewBox="0 0 486.48 506.08" width="22" height="22">
                    <path
                      d="m239.08,339.76c-78.9,0-143.07-76.2-143.07-169.88S160.17,0,239.08,0s143.06,76.2,143.06,169.88-64.17,169.88-143.06,169.88Zm0-295.9c-54.7,0-99.21,56.54-99.21,126.02s44.5,126.01,99.21,126.01,99.2-56.54,99.2-126.01-44.5-126.02-99.2-126.02Z" />
                    <path
                      d="m464.55,506.08H22.38c-11.56,0-21.16-9-21.89-20.56-9.34-149.06,117.75-198.15,186.28-203.29,11.78-1.07,22.49,8.14,23.47,20.22.95,12.04-8.09,22.58-20.17,23.52-6,.52-140.2,12.68-146.02,136.26h396.38c-6.86-41.38-35.13-127.05-152.19-136.26-12.08-.94-21.12-11.48-20.13-23.56.94-12.08,11.77-20.95,23.56-20.13,192.58,15.12,194.81,199.99,194.81,201.87,0,5.83-2.31,11.4-6.42,15.51-4.12,4.11-9.68,6.42-15.51,6.42Z" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="eye-container">
              <div class="input-label pass">
                <span @click="ShowPassword" class="eye-svg">
                  <EyeSvg />
                </span>
                <div class="svg-input">
                  <input :type="hidePass ? 'password' : 'text'" placeholder="رمز عبور" v-model="pass"
                    @keypress.enter="sendRequestOnEnter" />
                  <div class="svg-placeholder">
                    <svg fill="#9aa2ac" viewBox="0 0 486.32 506.08" width="22" height="26">
                      <path
                        d="m362.83,506.08H123.49C55.4,506.08,0,463.03,0,410.11v-188.32c0-12.09,12.59-21.86,28.14-21.86h430.04c15.55,0,28.14,9.78,28.14,21.86v188.32c0,52.92-55.4,95.97-123.49,95.97ZM56.28,243.66v166.45c0,28.78,30.17,52.23,67.21,52.23h239.33c37.04,0,67.21-23.45,67.21-52.23v-166.45H56.28Z" />
                      <path
                        d="m362.39,243.66c-15.55,0-28.14-9.78-28.14-21.87v-101.22c0-42.37-44.35-76.84-98.86-76.84s-98.87,34.47-98.87,76.84v101.22c0,12.09-12.59,21.87-28.14,21.87s-28.14-9.78-28.14-21.87v-101.22C80.24,54.07,149.82,0,235.39,0s155.14,54.07,155.14,120.58v101.22c0,12.09-12.59,21.87-28.14,21.87Z" />
                      <g>
                        <ellipse cx="241.23" cy="368.76" rx="47.53" ry="36.94" />
                        <path
                          d="m241.21,390.64c-15.55,0-28.14-9.78-28.14-21.87v-58.34c0-12.09,12.59-21.87,28.14-21.87s28.14,9.78,28.14,21.87v58.34c0,12.09-12.59,21.87-28.14,21.87Z" />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="sample-captcha">
              <vue-recaptcha @verify="handleVerify" />
            </div> -->

            <button class="login-button" @click="sendrequest(user, pass)">
              ورود به سامانه
            </button>
            <div class="privacy-link">
              <span> من </span>
              <a href="https://www.sinapardazesh.ir/privacy-policy" target="_blank" class="privacy-text"> سیاست حفظ حریم
                خصوصی </a>
              <span> و </span>
              <a href="https://www.sinapardazesh.ir/terms-of-service" target="_blank" class="privacy-text"> شرایط
                استفاده از خدمات </a>
              <span>را می‌پذیرم.</span>
            </div>
          </div>
        </div>
        <div class="mobile-loptop">
          <img :src="`${publicPath}img/nloptop.png`" alt="loptop background" />
        </div>
        <div class="license-row mobile">
          <div class="support-phone">
            <span>تلفن تماس: <a href="tel:02188745474" class="phone-link">۸۸۸۰۶۸۸۸-۰۲۱</a></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Demo Request Modal -->
  <div v-if="showDemoModal" class="modal-overlay">
    <div class="modal-content" @click.stop>
      <ModalHeader>
        <template #default>
          <h3>درخواست مشاهده دمو</h3>
        </template>
        <template #actions>
          <button @click="closeDemoModal" class="close-btn">&times;</button>
        </template>
      </ModalHeader>

      <div class="modal-body">
        <div v-if="!demoSuccess">
          <div class="form-group">
            <label>نام و نام خانوادگی</label>
            <input type="text" v-model="demoName" placeholder="نام و نام خانوادگی خود را وارد کنید"
              :disabled="demoLoading" />
          </div>

          <div class="form-group">
            <label>شماره تماس</label>
            <input type="tel" v-model="demoPhone" placeholder="شماره تماس خود را وارد کنید" class="rtl-input" dir="rtl"
              :disabled="demoLoading" />
          </div>

          <button @click="submitDemoRequest" class="submit-btn" :disabled="demoLoading">
            <span v-if="demoLoading">در حال ارسال...</span>
            <span v-else>ثبت و ارسال</span>
          </button>
        </div>

        <div v-else class="success-message">
          <div class="success-icon">✓</div>
          <h4>درخواست شما ثبت شد</h4>
          <p>همکاران ما در اولین فرصت با شما تماس می‌گیرند و اطلاعات دمو را برای شما ارسال می‌کنند.</p>
          <button @click="closeDemoModal" class="close-success-btn">بستن</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, ref, watch } from "vue";
import axios from "axios";
import router from "../../../router/index.js";
import Loader from "../../../components/Loader.vue";
import ModalHeader from '@/components/ModalHeader.vue';
// import { useReCaptcha } from "vue-recaptcha-v3";
import EyeSvg from "@/components/svgs/EyeSvg.vue";
import { useToast } from "vue-toastification";
import { useSettingStore } from "@/stores/clinic/setting.js";
// const { executeRecaptcha } = useReCaptcha();
const user = ref("");
const pass = ref("");
const loading = ref(false);
const hidePass = ref(true);
const settingStore = useSettingStore();
const { fetchSetting } = settingStore;
// Demo modal states
const showDemoModal = ref(false);
const demoName = ref("");
const demoPhone = ref("");
const demoLoading = ref(false);
const demoSuccess = ref(false);
const ShowPassword = () => {
  hidePass.value = !hidePass.value;
};
const toggle = ref(true);
const toast = useToast();
const API_URL = process.env.VUE_APP_BACKEND_URL;

// const API_URL = process.env.VUE_APP_BACKEND_URL;
const publicPath = process.env.BASE_URL;

async function sendrequest() {
  loading.value = true;
  try {
    const { data } = await axios.post(
      `${API_URL}/Authenticate/login`,
      {
        username: user.value,
        password: pass.value,
      }
    );
    console.log('Login success:', data.data)
    toast.success("خوش آمدید", {
      position: "top-right",
      timeout: 2000,
    });
    if (data.token) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("companyInfo", JSON.stringify(data.companyInfo));
      localStorage.setItem("storageInfo", JSON.stringify(data.storageInfo));
      localStorage.setItem("ismaster", toggle.value);

      // Determine company activation status.
      // Look for common naming: companyisactive, companyIsActive, isActive
      const companyInfo = data.companyInfo || JSON.parse(localStorage.getItem('companyInfo') || '{}');
      let isActive = false;
      if (companyInfo) {
        if (companyInfo.companyisactive !== undefined) {
          isActive = companyInfo.companyisactive === true || companyInfo.companyisactive === 'true';
        } else if (companyInfo.companyIsActive !== undefined) {
          isActive = companyInfo.companyIsActive === true || companyInfo.companyIsActive === 'true';
        } else if (companyInfo.isActive !== undefined) {
          isActive = companyInfo.isActive === true || companyInfo.isActive === 'true';
        }
      }

      // If the API returned a top-level flag in data (some backends might set it), consider it
      if (!isActive && data.companyisactive !== undefined) {
        isActive = data.companyisactive === true || data.companyisactive === 'true';
      }

      // Save activation to localStorage for later checks
      localStorage.setItem('companyisactive', isActive ? 'true' : 'false');

      await fetchSetting();

      if (isActive) {
        router.push("overview/clinic/clinic-dashboard");
      } else {
        // redirect to company setup page so user can complete company profile
        router.push({ path: '/company-setup' });
      }
    }
  } catch (err) {
    loading.value = false;
    console.log(err);
    if (err.response != undefined && (
      err.response.status === 401 ||
      err.response.status === 400 ||
      err.response.status === 500)
    ) {
      toast.error("نام کاربری یا رمز عبور شما اشتباه است. دوباره تلاش کنید.", {
        position: "top-right",
        timeout: 2000,
      });
    } else {
      console.log(err.message);
    }
  }
}
const sendRequestOnEnter = (e) => {
  if (e.key === "Enter") {
    sendrequest();
  }
};
// Demo form submission
const submitDemoRequest = async () => {
  if (!demoName.value.trim() || !demoPhone.value.trim()) {
    toast.error("لطفاً تمام فیلدها را پر کنید", {
      position: "top-right",
      timeout: 2000,
    });
    return;
  }

  demoLoading.value = true;
  try {
    // برای تست موقت - استفاده از console.log به جای API
    console.log("Demo Request Data:", {
      name: demoName.value,
      phone: demoPhone.value,
      email: "sales@sinapardazesh.ir",
      timestamp: new Date().toISOString()
    });

    // شبیه‌سازی ارسال موفق
    await new Promise(resolve => setTimeout(resolve, 1000));

    demoSuccess.value = true;
    demoName.value = "";
    demoPhone.value = "";

    toast.success("درخواست شما با موفقیت ارسال شد", {
      position: "top-right",
      timeout: 2000,
    });

    // اگر API endpoint موجود باشد، این کد را استفاده کنید:
    /*
    await axios.post(`${API_URL}demo-request.php`, {
      name: demoName.value,
      phone: demoPhone.value,
      email: "sales@sinapardazesh.ir"
    });
    */
  } catch (err) {
    console.log("Demo request error:", err);
    toast.error("خطا در ارسال درخواست. لطفاً دوباره تلاش کنید.", {
      position: "top-right",
      timeout: 2000,
    });
  } finally {
    demoLoading.value = false;
  }
};

const closeDemoModal = () => {
  showDemoModal.value = false;
  demoSuccess.value = false;
  demoName.value = "";
  demoPhone.value = "";
};
const offline = ref(false);
watch(offline, () => {
  if (offline.value) {
    toast.error(
      "ارتباط با سرور برقرار نشد لطفا ارتباط خود با اینترنت را چک کنید",
      {
        position: "top-right",
        timeout: 0,
        closeButton: false,
        draggable: false,
      }
    );
  }
});
onBeforeMount(() => {
  window.addEventListener("offline", function () {
    offline.value = true;
  });
  window.addEventListener("online", function () {
    offline.value = false;
    toast.clear();
  });
});
</script>
<style scoped lang="scss">
.mobile-login-page {
  display: none;
}

.sample-captcha {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  justify-content: space-between;

  input {
    width: 40%;
    background-color: #f5f5f5;
    border: none;
    border-radius: 15px;
    padding: 10px;

    &:focus {
      border: none;
      outline: none;
    }
  }
}

.input-container {
  width: 100dvw;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1476f3;
}

.mobile-logo {
  display: none;
}

.mobile-loptop {
  display: none;
}

.mobile-text {
  display: none;
}

.license-row {

  grid-template-columns: 1fr 1fr;
  gap: 8px;
  align-items: center;
  color: #fff;
}

.license-row .license-right {
  text-align: center;
  justify-self: center;
  width: 100%;
}

.license-row .license-left {
  text-align: left;
}

.shadow-desktop {
  -webkit-box-shadow: 0px 0px 33px 1px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.4);
  padding: 30px;
  margin-top: 1rem;
  border-radius: 15px;
}

.input-wrapper {
  width: 70%;
  height: 70%;
  background-color: white;
  display: flex;
  border-radius: 1.5rem;
  -webkit-box-shadow: 0px 0px 33px 1px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 0px 33px 1px rgba(0, 0, 0, 0.4);
}

.side {
  width: 100%;
}

.main {
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.main-container {
  display: flex;
  flex-direction: column;
  justify-content: center;

  border-radius: 1.5rem;
}

.other {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-image: url("../../../../public/img/background.webp");
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 1.4rem 0rem 0rem 1.4rem;
  padding-bottom: 1rem;
}

.other .text {
  color: white;
  font-size: 0.8rem;
  text-align: center;
}

.license-row.desktop {
  color: #fff;
  margin-top: 8px;
}

.support-phone.desktop-right {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.9rem;
  color: #1c3f79;
  font-weight: 500;
  padding: 0.5rem;
}

.phone-link {
  color: #1c3f79;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
    color: #1476f3;
  }
}

.logo img {
  position: absolute;
  top: 0; /* move logo to top */
  right: 3%;
  width: 250px;
  z-index: 5;
}

.loptop img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%) scale(0.9);
}

.input-heading {
  font-weight: 700;
  font-size: 1.4rem;
  color: #1c407a;
  text-align: center;
}

.input-heading .bold {
  color: #1476f3;
}

.spacer {
  text-align: center;
  border: #1c407a8f solid 1px;
  margin: 1rem 1rem;
  margin-left: 1.5rem;
}

.subtext {
  text-align: center;
  color: #9aa2ac;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.switch-wrapper {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-label {
  text-align: right;
  margin-top: 1rem;
}

.input-container h3 {
  margin-top: 0;
}

.login-button {
  background: linear-gradient(to right, #1476f3 10%, #1c407a 90%);
  color: white;
  border: none;
  border-radius: 2rem;
  width: 100%;
  padding: 0.7rem 0;
}

.privacy-link {
  margin-top: 1rem;
  text-align: center;
  font-size: 0.8rem;
  line-height: 1.4;
}

.privacy-text {
  color: #1476f3;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.support-phone {
  margin-top: 1rem;
  text-align: center;
  font-size: 0.9rem;
  color: #1c3f79;
  font-weight: 500;
}

.demo-link {
  margin: 1rem 0;
  text-align: center;
}

.demo-link-text {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #1476f3;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border: 1px solid #1476f3;
  border-radius: 1rem;
  transition: all 0.3s ease;
  background: none;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    background-color: #1476f3;
    color: white;
    text-decoration: none;
  }
}

.demo-text {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  justify-content: center;

  svg {
    fill: #9aa2ac;
    height: 15px;
  }

  span {
    &:first-child {
      margin-left: 5px;
      color: #9aa2ac;
      font-weight: bold;
      font-size: 13px;
    }

    &:last-child {
      margin-right: 5px;
      color: #1476f3;
      cursor: pointer;
      font-weight: bold;
      font-size: 13px;
    }
  }
}

@media only screen and (max-width: 1450px) {
  .main-container {
    padding: 0 8%;
  }

  .logo img {
    right: 4%;
    width: 220px;
  }

  .loptop img {
    transform: translateY(-50%) translateX(-50%) scale(0.75);
  }
}

@media only screen and (max-width: 1372px) {
  .main-container {
    padding: 0 8%;
  }
}

@media only screen and (max-width: 1312px) {
  .main-container {
    padding: 0 5%;
  }
}

@media only screen and (max-width: 1024px) {
  .main-container {
    padding: 0 1%;
  }

  .input-wrapper {
    width: 90%;
  }

  .logo img {
    transform: scale(0.9);
  }

  .loptop img {
    transform: translateY(-50%) translateX(-50%) scale(0.7);
  }

  .other .text {
    font-size: 11px;
  }
}

@media only screen and (max-width: 768px) {
  .login-page {
    overflow-x: hidden;
  }

  .main-container {
    padding: 0 5%;
  }

  .input-wrapper {
    width: 95%;
  }

  .loptop img {
    transform: translateY(-50%) translateX(-50%) scale(0.6);
  }

  .input-heading {
    font-size: 1.1rem;
  }

  .subtext {
    font-size: 0.8rem;
  }

  .other .text {
    font-size: 9px;
  }
}

@media only screen and (max-width: 710px) {
  .login-page {
    display: none;
  }

  .demo-text {
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      fill: #9aa2ac;
      height: 15px;
    }

    span {
      &:first-child {
        margin-left: 5px;
        color: #9aa2ac;
        font-weight: bold;
        font-size: 13px;
      }

      &:last-child {
        margin-right: 5px;
        color: #1476f3;
        cursor: pointer;
        font-weight: bold;
        font-size: 13px;
      }
    }
  }

  .mobile-login-page {
    display: flex;
    width: 100vw;
    height: 100dvh;
    background-color: #1476f3;

    .spacer {
      margin-bottom: 0;
    }

    .innerframe {
      -webkit-box-shadow: 0px 0px 33px 1px rgba(0, 0, 0, 0.4);
      box-shadow: 0px 0px 5px 1px rgba(116, 116, 116, 0.4);
      border-radius: 16px;
      padding: 0 10px;
      padding-bottom: 10px;
    }

    .mobile-login-container {
      position: relative;

      .photo-mobile {
        position: absolute;
        top: 11%;
        right: 50%;
        transform: translateX(50%);

        img {
          width: 300px;
        }

        z-index: 0;
      }

      .logo-mobile {
        position: absolute;
        top: 10px;
        right: 50%;
        transform: translateX(50%);

        img {
          width: 250px;
        }
      }

      background-image: url("../../../../public/img/background.webp");
      background-size: contain;
      -webkit-box-shadow: 0px 0px 33px 1px rgba(0, 0, 0, 0.4);
      box-shadow: 0px 0px 33px 1px rgba(0, 0, 0, 0.4);
      // background-repeat: no-repeat;
      margin: 20px;
      display: flex;
      width: 100%;
      justify-content: flex-end;
      align-items: flex-end;
      border-radius: 35px;

      .main.side {
        z-index: 4;
        border-radius: 0 0 24px 24px;
        background-color: white;
        display: inline;

        .main-container {
          padding: 10px;
        }

        .subtext {
          margin-top: 20px;
          margin-bottom: 20px;
        }

        .input-heading {
          text-align: center;
          width: 100%;
          font-size: 1.2rem;
        }

        .input-label.user {
          margin-top: 0rem;
          margin-bottom: 20px;
        }

        .input-label.pass {
          margin-top: 0rem;
          margin-bottom: 20px;
        }

        .switch-wrapper {
          margin-top: 20px;
          margin-bottom: 20px;
        }

        .login-button {
          padding: 0.5rem;
        }

        .license-row.mobile {
          color: #fff;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;

          .support-phone {
            color: #1c3f79;
            text-align: center;
            font-size: 0.9rem;
            font-weight: 500;
            margin-top: 0.5rem;
            width: 100%;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 376px) {
  .mobile-login-page {
    .mobile-login-container {
      .photo-mobile {
        top: 15%;

        img {
          width: 250px;
        }
      }

      .logo-mobile {
        img {
          width: 200px;
        }
      }

      margin: 20px 16px;

      .main.side {
        .main-container {
          padding: 9px;
        }

        .subtext {
          font-size: 0.7rem;
          margin-top: 0.8rem;
          margin-bottom: 1.8rem;
        }

        .input-heading {
          font-size: 1.1rem;
        }

        .input-label.user {
          margin-top: 0rem;
        }

        .input-label {
          margin-bottom: 0.5rem;
        }

        .switch-wrapper {
          margin-top: 20px;
          margin-bottom: 20px;
        }
      }
    }
  }
}

@media only screen and (max-width: 320px) {
  .mobile-login-page {
    .demo-text {
      margin: 15px 0;

      svg {
        height: 12px;
      }

      span {
        &:first-child {
          margin-left: 5px;
          font-size: 12px;
        }

        &:last-child {
          margin-right: 5px;
          font-size: 12px;
        }
      }
    }

    .mobile-login-container {
      background-size: 100% 60%;

      .photo-mobile {
        top: 10%;

        img {
          width: 230px;
        }
      }

      .logo-mobile {
        img {
          width: 180px;
        }
      }

      margin: 20px 10px;

      .main.side {
        .main-container {
          padding: 10px 10px;
        }

        .subtext {
          font-size: 0.6rem;
          margin-top: 0.5rem;
          margin-bottom: 1.5rem;
        }

        .input-heading {
          font-size: 0.9rem;
        }

        .input-label.user {
          margin-top: 0rem;
        }

        .input-label {
          margin-bottom: 0.5rem;
        }

        .switch-wrapper {
          margin-top: 20px;
          margin-bottom: 20px;
        }
      }
    }
  }
}

// Modal styles
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  direction: rtl;
}

.modal-content {
  background: white;
  border-radius: 15px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0px 0px 33px 1px rgba(0, 0, 0, 0.4);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e5e5;

  h3 {
    margin: 0;
    color: #1c407a;
    font-size: 1.2rem;
    font-weight: 600;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #9aa2ac;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;

    &:hover {
      background-color: #f5f5f5;
      color: #1c407a;
    }
  }
}

.modal-body {
  padding: 1.5rem;

  .form-group {
    margin-bottom: 1.5rem;

    label {
      display: block;
      margin-bottom: 0.5rem;
      color: #1c407a;
      font-weight: 500;
      font-size: 0.9rem;
    }

    input {
      width: 100%;
      padding: 0.75rem;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      font-size: 0.9rem;
      transition: border-color 0.3s ease;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: #1476f3;
        box-shadow: 0 0 0 2px rgba(20, 118, 243, 0.1);
      }

      &:disabled {
        background-color: #f5f5f5;
        color: #9aa2ac;
        cursor: not-allowed;
      }

      &::placeholder {
        color: #9aa2ac;
      }
    }
  }

  // Force RTL and right alignment for phone input in demo modal
  .rtl-input {
    direction: rtl;
    text-align: right;
  }

  .submit-btn {
    width: 100%;
    background: linear-gradient(to right, #1476f3 10%, #1c407a 90%);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0.75rem;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(20, 118, 243, 0.3);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }
}

.success-message {
  text-align: center;
  padding: 1rem 0;

  .success-icon {
    width: 60px;
    height: 60px;
    background-color: #4caf50;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    margin: 0 auto 1rem;
  }

  h4 {
    color: #1c407a;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }

  p {
    color: #9aa2ac;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }

  .close-success-btn {
    background: linear-gradient(to right, #1476f3 10%, #1c407a 90%);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(20, 118, 243, 0.3);
    }
  }
}

// Mobile responsive for modal
@media only screen and (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 1rem;
  }

  .modal-header {
    padding: 1rem;

    h3 {
      font-size: 1.1rem;
    }
  }

  .modal-body {
    padding: 1rem;
  }
}
</style>
